const handler = function (e) {
  e.preventDefault()
}
function closeTouch () {
  document.getElementsByTagName('body')[0].addEventListener('touchmove',
    handler, {passive: false})// 阻止默认事件
}
function openTouch () {
  document.getElementsByTagName('body')[0].removeEventListener('touchmove',
    handler, {passive: false})// 打开默认事件
}
/**
* 检测图片是否存在
* @param url
*/
let imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete === true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}
export default (Vue) => {
  Vue.directive('roll', {
    componentUpdated (el, binding) {
      if (binding.value instanceof Array) {
        const visible = binding.value.some(e => e) // 当视图所有控制弹层的变量存在一个是true，即可阻止touchmove事件
        if (visible) {
          closeTouch()
        } else {
          openTouch()
        }
      } else if (typeof binding.value === 'boolean') {
        if (binding.value) {
          closeTouch()
        } else {
          openTouch()
        }
      }
    }
  })
  // 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
  Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
    let imgURL = binding.value// 获取图片地址
    if (imgURL) {
      let exist = await imageIsExist(imgURL)
      if (exist) {
        el.setAttribute('src', imgURL)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/directives.js